<template>
    <div class="container">
      <div class="panel panel-default">
        <div class="panel-heading">
          <div class="category">
            <a class="category-top">基本资料</a>
            <a class="category-bottom">Basic data</a>
          </div>
        </div>
        <div class="panel-body" style="padding: 0px">
          <div class="container">
            <table class="table">
              <thead>
                <tr>
                  <th width="18%"></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="blue"><p>中文名称</p></td>
                  <td>{{ info.DicName }}</td>
                </tr>
                <tr>
                  <td class="blue"><p>行政面积</p></td>
                  <td>{{ info.Area ? info.Area : "暂无" }}</td>
                </tr>
                <tr>
                  <td class="blue"><p>境内人口</p></td>
                  <td>{{ info.MaxLoad ? info.MaxLoad : "暂无" }}</td>
                </tr>
                <tr>
                  <td class="blue"><p>所获荣誉</p></td>
                  <td>{{ info.Honour ? info.Honour : "暂无" }}</td>
                </tr>
                <tr>
                  <td class="blue"><p>主要景点</p></td>
                  <td>{{ info.MainScenic ? info.MainScenic : "暂无" }}</td>
                </tr>
                <tr>
                  <td class="blue"><p>主要酒店</p></td>
                  <td>{{ info.NearbyScenic ? info.NearbyScenic : "暂无" }}</td>
                </tr>
                <tr>
                  <td class="blue"><p>餐饮农家</p></td>
                  <td>{{ info.BoomSeason ? info.BoomSeason : "暂无" }}</td>
                </tr>
                <tr>
                  <td class="blue"><p>旅游商品</p></td>
                  <td>{{ info.Cate ? info.Cate : "暂无" }}</td>
                </tr>
                <tr>
                  <td class="blue"><p>历史名人</p></td>
                  <td>{{ info.SpecialGoods ? info.SpecialGoods : "暂无" }}</td>
                </tr>
                <tr>
                  <td class="blue"><p>文化非遗</p></td>
                  <td>{{ info.JudgeGrade ? info.JudgeGrade : "暂无" }}</td>
                </tr>
                <tr>
                  <td class="blue"><p>行政区划</p></td>
                  <td v-if="info.city && info.district">
                    安徽省-{{ info.city.RegionName }}-{{
                      info.district.RegionName
                    }}{{ info.town ? "-" + info.town.RegionName : "" }}
                  </td>
                  <td v-else>暂无</td>
                </tr>
                <tr>
                  <td class="blue"><p>最近机场</p></td>
                  <td>{{ info.Airfield ? info.Airfield : "暂无" }}</td>
                </tr>
                <tr>
                  <td class="blue"><p>最近铁路</p></td>
                  <td>{{ info.Railroad ? info.Railroad : "暂无" }}</td>
                </tr>
                <tr>
                  <td class="blue"><p>最近高速</p></td>
                  <td>{{ info.HVRoad ? info.HVRoad : "暂无" }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
name:'',
props:{
    info: Object
},
  data () {
    return {
    };
  },

  components: {},

  computed: {},

  methods: {}
}

</script>
<style scoped>
</style>